import React from 'react';
import { useTranslation } from 'react-i18next';
import _startCase from 'lodash/startCase';
import { TextMedia } from 'pages/Machine/styled';

import { CounterBlock } from '@m12s/component-library';
import { CounterLabel } from 'components/WheelLayout';
import { PrimaryDisplayValue } from 'lib/utils/styled';
import { CyclesTimeCounter } from './CycleTimeCounter';

export const CycleTimeCounterDisplay = () => {
  const { t } = useTranslation();

  return (
    <CounterBlock
      label={
        <CounterLabel>
          <TextMedia max={60}>{_startCase(t('cycle'))}</TextMedia>
          <TextMedia min={60}>{_startCase(t('current cycle'))}</TextMedia>
        </CounterLabel>
      }
      value={
        <PrimaryDisplayValue>
          <CyclesTimeCounter />
        </PrimaryDisplayValue>
      }
      align="right"
    />
  );
};
